export var FOCUSABLE_ELEMENTS = ["BUTTON", "TEXTAREA", "SELECT"];
var BASE_FOCUSABLE_ELEMENTS = 'a[href],area[href],input:not([disabled]):not([type="hidden"])';
var BASE_FOCUSABLE_QUERY = FOCUSABLE_ELEMENTS.reduce(function (queryString, element) { return "".concat(queryString, ",").concat(element, ":not([disabled])"); }, BASE_FOCUSABLE_ELEMENTS);
/**
 * A query selector to find elements that are programmatically focusable.
 *
 * Example:
 *
 * ```ts
 * const focusableElements = document.querySelectorAll(PROGRAMATICALLY_FOCUSABLE);
 * // do something with elements
 * ```
 */
export var PROGRAMATICALLY_FOCUSABLE = "".concat(BASE_FOCUSABLE_QUERY, ",[tabindex]");
/**
 * A query selector to find elements that are focusable only with tab and shift+tab.
 *
 * Example:
 *
 * ```ts
 * const focusableElements = document.querySelectorAll(TAB_FOCUSABLE);
 * // do something with elements
 * ```
 */
export var TAB_FOCUSABLE = "".concat(PROGRAMATICALLY_FOCUSABLE, ":not([tabindex=\"-1\"])");
//# sourceMappingURL=constants.js.map